var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{staticClass:"nav-fill",attrs:{"card":""}},[_c('b-tab',{attrs:{"title":"검색어 현황"}},[_c('SearchHistoryList')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"인기검색어 설정"}},[_c('SearchManageList')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"제외어 설정"}},[_c('SearchExceptManageList')],1)],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63584aa0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/site/search/component/SearchTabs.vue
// module id = null
// module chunks = 